import React, { Fragment, useEffect, useState } from "react";

import { Radio, Col, Row } from "antd";
import moment from "moment";

import ButtonComponent from "@/components/button/Button";
import CardComponent from "@/components/card";

import "@/styles/components/datepicker.scss";
import ModalComponent from "@/components/modal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setModalOpen } from "@/reducers/commonSlice";
import { setCheckoutType, setSessionData } from "@/reducers/checkoutSlice";
import { getGuideAvailibilityById } from "@/services/services/getGuideAvailibilityById";
import { getActiveGuide } from "@/reducers/guideSlice";
import { getSessionPrice } from "@/services/services/getSessionPrice";
import { convertSlotToLocalTime } from "@/helpers";
import { getCountryTimeZone } from "@/helpers/getCountryZone";

const DatePickerComponent = ({
  isOpen = false,
  selectedDateProp = null,
  durationProp = "30min",
  handleUpdateSession = () => {},
  isUpdate = false,
}) => {
  // const halfHours = [
  //   "04:30pm",
  //   "05:00pm",
  //   "05:30pm",
  //   "06:00pm",
  //   "06:30pm",
  //   "07:00pm",
  //   "07:30pm",
  //   "08:00pm",
  // ];
  // const fullHours = [
  //   "04:00pm",
  //   "05:00pm",
  //   "06:00pm",
  //   "07:00pm",
  //   "08:00pm",
  //   "09:00pm",
  //   "10:00pm",
  //   "11:00pm",
  // ];

  const [sessionDuration, setSessionDuration] = useState("30min");
  const [sessionDurationHours, setSessionDurationHours] = useState([]);
  const [selectedTime, setSelectedTime] = useState([]);

  const [startDate, setStartDate] = useState(moment().subtract(1, "days"));
  const [selectedDate, setSelectedDate] = useState(selectedDateProp || moment().add(1, "days"));
  const [timezone, setTimezone] = useState();

  // const [guideAvalibility, setGuideAvailibility] = useState([]);

  const guideData = useSelector(getActiveGuide);
  const handleDurationChange = (e) => {
    setSessionDuration(e.target.value);
    setSelectedTime([]);
  };

  const handleTimeChange = (time, index) => {
    if (sessionDuration === "60min") {
      if (
        sessionDurationHours.findIndex((x) => x.localStart == time.localStart) !==
        sessionDurationHours.length - 1
      ) {
        const nextSlot = sessionDurationHours.find((x) => x.localStart == time.localEnd);
        if (!!Object.keys(nextSlot ?? {}).length) {
          if (!nextSlot.isBooked) {
            setSelectedTime([
              {
                start: time.start,
                end: time.end,
                orignalDate: time.date,
                localStart: time.localStart,
                localEnd: time.localEnd,
              },
              {
                start: nextSlot.start,
                end: nextSlot.end,
                orignalDate: time.date,
                localStart: nextSlot.localStart,
                localEnd: nextSlot.localEnd,
              },
            ]);
          }
        }
      }
    } else {
      setSelectedTime([
        {
          start: time.start,
          end: time.end,
          orignalDate: time.date,
          localStart: time.localStart,
          localEnd: time.localEnd,
        },
      ]);
    }
  };

  const handleNextWeek = () => {
    setStartDate(startDate.clone().add(7, "days"));
  };

  const handlePreviousWeek = () => {
    setStartDate(startDate.clone().subtract(7, "days"));
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedTime([]);
  };

  const renderDates = () => {
    let dates = [];
    for (let i = 0; i < 7; i++) {
      dates.push(startDate.clone().add(i, "days"));
    }
    return dates;
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const updateSessionDurationHour = (guideId, selectedDate) => {
    getGuideAvailibilityById(guideId, moment(selectedDate).format("YYYY-MM-DD")).then((res) => {
      setSessionDurationHours(
        convertSlotToLocalTime(res, moment(selectedDate).format("YYYY-MM-DD"))
      );
    });
  };
  useEffect(() => {
    if (guideData) {
      updateSessionDurationHour(guideData.id, selectedDate);
    }
  }, [guideData, selectedDate]);

  const handleSelectData = async () => {
    dispatch(setModalOpen(false));
    if (isUpdate) {
      handleUpdateSession({
        date: selectedDate,
        time: selectedTime,
        duration: sessionDuration,
      });
    } else {
      dispatch(setCheckoutType(false));
      const sessionPrice = await getSessionPrice();
      const priceKey = sessionDuration === "30min" ? 30 : 60;
      const amount = sessionPrice[priceKey]?.amount;
      dispatch(
        setSessionData({
          price: amount,
          date: moment(selectedDate).format("DD MMM YYYY"),
          time: selectedTime,
          duration: sessionDuration,
          guideName: guideData.firstName + " " + guideData.lastName,
          guideId: guideData.id,
        })
      );
      navigate("/checkout-preview");
    }
  };

  useEffect(() => {
    if (isOpen) {
      if (selectedDateProp && durationProp) {
        setSelectedDate(selectedDateProp);
        setSessionDuration(durationProp);
        updateSessionDurationHour(guideData.id, selectedDateProp);
      } else {
        setSelectedDate(moment().add(1, "days"));
        setSessionDuration("30min");
      }
      setSelectedTime([]);
    } else {
      setSelectedDate(moment().add(1, "days"));
      setSelectedTime([]);
      setSessionDuration("30min");
    }
  }, [isOpen, selectedDateProp, durationProp]);

  useEffect(() => {
    setTimezone(getCountryTimeZone());
  }, []);

  return (
    <Fragment>
      <ModalComponent isOpen={isOpen} width={600}>
        <CardComponent>
          <div className="date-time-picker">
            <div className="heading title-h5-1">Choose Date & Time</div>

            <div className="session-date">
              <div className="heading body-b1">Select Session Date:</div>
              <div className="select-session-date">
                <div className="month-year">
                  <div className="previous" onClick={handlePreviousWeek}>
                    &lt;
                  </div>
                  <div>
                    <div>{startDate.format("MMMM YYYY")}</div>
                  </div>
                  <div className="next" onClick={handleNextWeek}>
                    &gt;
                  </div>
                </div>
                <div className="date-row">
                  {renderDates().map((date, index) => (
                    <div
                      key={index}
                      onClick={() =>
                        !date.isBefore(moment().add(1, "days"), "day") && handleDateChange(date)
                      }
                    >
                      <div
                        className={`day ${
                          date.isBefore(moment().add(1, "days"), "day") ? "disabled" : ""
                        } ${date.isSame(selectedDate, "day") ? "body-b4" : "body-b4"}`}
                      >
                        {date.format("ddd")}
                      </div>
                      <div
                        className={`date ${
                          date.isBefore(moment().add(1, "days"), "day") ? "disabled" : ""
                        } 
                         ${date.isSame(moment(), "day") ? "currentDay" : ""}
                        ${date.isSame(selectedDate, "day") ? "active title-h6-1" : "title-h6-1"}`}
                      >
                        {date.format("D")}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {isUpdate ? null : (
              <div className="session-duration">
                <div className="heading body-b1">Select Session Duration:</div>
                <Radio.Group onChange={handleDurationChange} value={sessionDuration}>
                  <Radio value="30min">30min Session</Radio>
                  <Radio value="60min">60min Session</Radio>
                </Radio.Group>
              </div>
            )}

            <div className="session-slots">
              <div className="heading body-b1">
                Select Session Slots {timezone ? `(${timezone})` : ""}
              </div>
              <div className="slots">
                <Row gutter={[8, 8]}>
                  {sessionDurationHours.length ? (
                    sessionDurationHours?.map((slot, index) => (
                      <Col xs={12} sm={12} md={6} lg={6} key={index}>
                        <div
                          className={
                            slot.isBooked || slot.isUnavailable
                              ? "disabled"
                              : selectedTime?.filter((x) => x.start === slot.start)?.length
                                ? "active"
                                : "slot"
                          }
                          onClick={() =>
                            !slot.isBooked && !slot.isUnavailable
                              ? handleTimeChange(slot, index)
                              : {}
                          }
                        >
                          <CardComponent>{slot?.localStart}</CardComponent>
                        </div>
                      </Col>
                    ))
                  ) : (
                    <div style={{ textAlign: "center", width: "100%" }}>No Slot available</div>
                  )}
                </Row>
              </div>
            </div>

            <div className="submit">
              <ButtonComponent
                type="primary"
                label="Select Date & Time"
                disabled={!selectedTime.length}
                onClick={handleSelectData}
              />
            </div>

            <div className="datepicker-footer">
              <div className="available">
                <div className="circle"></div>
                <div className="label body-b4">Available</div>
              </div>
              <div className="not-available">
                <div className="circle"></div>
                <div className="label body-b4">Not Available</div>
              </div>
              <div className="selected">
                <div className="circle"></div>
                <div className="label body-b4">Selected</div>
              </div>
            </div>
          </div>
        </CardComponent>
      </ModalComponent>
    </Fragment>
  );
};

export default DatePickerComponent;
